// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"276e0810","553":"cb60423a","977":"1c6f18b5"}[chunkId] + ".chunk.js";
};